import { render, staticRenderFns } from "./UsuarioPage.vue?vue&type=template&id=ebbff040"
import script from "./UsuarioPage.js?vue&type=script&lang=js&external"
export * from "./UsuarioPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports